module.exports = __webpack_public_path__ + "img/calendar-arrow-up.b46f72f0.svg";